import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-urgent-priority_afdd98f28ee5161e53b5e8a2f8919a05",
  "use": "ic-urgent-priority_afdd98f28ee5161e53b5e8a2f8919a05-usage",
  "viewBox": "0 0 14 11",
  "content": "<symbol viewBox=\"0 0 14 11\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-urgent-priority_afdd98f28ee5161e53b5e8a2f8919a05\">\n<path d=\"M6.6 0L13.2 11H0L6.6 0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol